import { createExtension } from '@blocknote/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { FurtherBlockNoteExtensionContext } from '../schema';
import ensureParagraphAfterBlockAndFocus from './ensure-paragraph-after-block-and-focus';
import findBlockToSeparateOnEnter from './find-block-to-separate-on-enter';

const pluginKey = new PluginKey('insertParagraphBetweenAdjacentMediaOnEnter');

export const insertParagraphBetweenAdjacentMediaOnEnterExtension =
  createExtension(({ editor }: FurtherBlockNoteExtensionContext) => {
    const handleEnter = () => {
      const insertAfter = findBlockToSeparateOnEnter(editor);
      if (!insertAfter) {
        return false;
      }

      ensureParagraphAfterBlockAndFocus(editor, insertAfter);
      return true;
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Enter' || event.shiftKey || !editor.isEditable) {
        return;
      }

      if (!handleEnter()) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    };

    return {
      key: 'insertParagraphBetweenAdjacentMediaOnEnter',
      keyboardShortcuts: {
        Enter: handleEnter,
      },
      prosemirrorPlugins: [
        new Plugin({
          key: pluginKey,
          props: {
            handleKeyDown(_view, event) {
              if (
                event.key !== 'Enter' ||
                event.shiftKey ||
                !editor.isEditable
              ) {
                return false;
              }

              if (!handleEnter()) {
                return false;
              }

              event.preventDefault();
              return true;
            },
          },
        }),
      ],
      mount: ({ dom }) => {
        dom.addEventListener('keydown', handleKeyDown, true);

        return () => {
          dom.removeEventListener('keydown', handleKeyDown, true);
        };
      },
    };
  });
